import axios from 'axios'

const api = axios.create()
const sema = axios.create()
sema.defaults.withCredentials = true

export { api, sema }
